/**
 * Makes a lazy-loaded admin-ajax call to asynchronously load a related content template partial
 * https://github.com/emn178/jquery-lazyload-any
 *
 * @param string $path The path from the child theme to the template partial
 * @param string $partial The name of the partial to load
 * @param string $nonce The WP generated security nonce
 */

jQuery( document ).ready(
	function($){
        var $lazyLoadElement = $(".lazy-load");
        if ($lazyLoadElement.length) {
            $lazyLoadElement.lazyload(
                {
                    threshold: 300, // Trigger the load 300px before the element comes into view
                    load: function (element) {
                        // Get the 'lang' param for language previewing on the Hub
                        var query_string = window.location.search;
                        var url_params = new URLSearchParams(query_string);
                        var language = url_params.get('lang')

                        $.post(
                            localized.ajax_url,
                            {
                                'action': 'jh_async_related_content',
                                'partial_path': $(element).data('partial-path'),
                                'partial_name': $(element).data('partial-name'),
                                'async-post-id': $(element).data('async-post-id'),
                                'async-args': $(element).data('async-args'),
                                'nonce': $(element).data('nonce'),
                                'lang': language
                            },
                            function (response) {
                                if (0 !== response) {
                                    // Append the async related content and remove the inline placeholder styling
                                    $('#' + $(element).data('partial-name') + '-async-container').prepend($.parseHTML(response))
                                        .hide().fadeIn(300).animate( // Fade in the content
                                        {
                                            minHeight: '100%',
                                        },
                                        {
                                            duration: 150,
                                            complete: function () {
                                                $(this).removeAttr('style')
                                            }
                                        }
                                    );

                                    $('#' + $(element).data('partial-name') + '-skeleton-box-container').fadeOut(250).remove()

                                    // If we're loading a carousel trigger its build
                                    if ($(element).data('partial-name').includes('carousel')) {
                                        build_insights_carousel($(window).width());
                                        // Manually start the slide cycle timer
                                        $('.carousel').carousel('cycle');
                                    }
                                    // Homepage Tooltip trigger
                                    $('.homepage-tooltip').find('[data-toggle="tooltip"]').tooltip({trigger: 'click', offset: '5,10'});

                                }
                            }
                        );
                    }
                }
            );

            $.lazyload.check();
        }
	}
);
